import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export type BadgeVariant =
  | 'neutral'
  | 'primary'
  | 'accent'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info';

const VARIANTS: Record<BadgeVariant, string> = {
  neutral: 'bg-background-200 text-foreground-700 border-background-300',
  primary: 'bg-primary-100 text-primary-800 border-primary-200',
  accent: 'bg-accent-100 text-accent-800 border-accent-200',
  success: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  warning: 'bg-amber-50 text-amber-700 border-amber-200',
  danger: 'bg-rose-50 text-rose-700 border-rose-200',
  info: 'bg-secondary-100 text-secondary-800 border-secondary-200',
};

interface BadgeProps {
  variant?: BadgeVariant;
  icon?: string;
  className?: string;
  children: ReactNode;
}

export default function Badge({ variant = 'neutral', icon, className, children }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-1 text-xs font-medium',
        VARIANTS[variant],
        className,
      )}
    >
      {icon ? <i className={cn(icon, 'text-[1.05em] leading-none')} aria-hidden="true" /> : null}
      {children}
    </span>
  );
}